import { CardGridSectionProps } from "@/constants/type/card"


export default function CardGridSection({
    sectionClass = "fp-container-fluid",
    cards,
    topContent,
}: CardGridSectionProps) {
    return (
        <section className={sectionClass}>
            <div className="fp-container">

                {topContent && (
                    <div className="fp-row">
                        <div className="cell-lg-8">{topContent}</div>
                    </div>
                )}

                <div className="fp-row">
                    {cards.map((card, index) => (
                        <div className="cell-lg-4" key={index}>
                            <div className="fp-card">
                                <img src={card.icon} alt={card.alt} className="icon" />
                                <h3>{card.title}</h3>
                                <p>{card.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

